import { toast } from 'react-toastify';

const duplicateNameChecker = async (name, dataList, updateData, setDuplicateNameExist) => {
    if(dataList.length === 0){
        return setDuplicateNameExist(false)
    }else{
        for(let i=0; i< dataList.length; i ++){
            if(updateData){
                if(updateData.name === name){
                    return setDuplicateNameExist(false)
                }else{
                    if (dataList[i].name === name){
                        toast.warning("Name already exists!");
                        return setDuplicateNameExist(true);
                    }
                }
            }else{
                if (dataList[i].name === name){
                    toast.warning("Name already exists!");
                    return setDuplicateNameExist(true);
                }
            }
        }
        return setDuplicateNameExist(false);
    }
};

export default duplicateNameChecker;